import React, { useEffect, useState } from "react";
import SettingsModal from "../../../../organisms/settings-modal/SettingsModal";
import { EyeIcon, MoreDotIcon } from "../../../../assets/Icons";
import { getMaterial } from "../../../../../redux/materialSlice";
import { getCompany } from "../../../../../redux/companySlice";
import { useSelector } from "react-redux";
import { ENDPOINTS } from "../../../utils/endpoints";

function Actions() {
  const material = useSelector((state) => getMaterial(state));
  const company = useSelector((state) => getCompany(state));
  const [settingsOpen, setSettingsOpen] = useState(false);

  const showPreview = () => {
    window.location.href = ENDPOINTS.VIEW_PATH(company.slug, material.slug);
  };

  // Settings/theme now lives behind the kebab (per the redesign). Reuses the same
  // Bootstrap SettingsModal the gear opened — relocated, not removed.
  const openSettings = () => setSettingsOpen(true);
  const closeSettings = () => {
    setSettingsOpen(false);
    $("#settingsModal").modal("hide");
  };

  useEffect(() => {
    if (!settingsOpen) return undefined;
    const id = window.requestAnimationFrame(() => $("#settingsModal").modal("show"));
    return () => window.cancelAnimationFrame(id);
  }, [settingsOpen]);

  useEffect(() => {
    const handler = () => setSettingsOpen(false);
    $("#settingsModal").on("hidden.bs.modal", handler);
    return () => $("#settingsModal").off("hidden.bs.modal", handler);
  }, []);

  return (
    <div className="action-sloat-path un-actions">
      {settingsOpen && <SettingsModal open={settingsOpen} onClose={closeSettings} />}
      <div className="item-action-sloat-path un-action un-pe-iconbtn">
        <div className="buttons-action-path">
          <EyeIcon onClick={showPreview} />
        </div>
      </div>
      <div className="item-action-sloat-path un-action un-pe-iconbtn" onClick={openSettings}>
        <div className="buttons-action-path">
          <MoreDotIcon />
        </div>
      </div>
    </div>
  );
}

export default Actions;
